import { CONTINUOUS_FEEDBACK_RELOAD_STATUS } from './actionTypes';

export const reloadFeedbackList = ({ reloadType }) => ({
  type: CONTINUOUS_FEEDBACK_RELOAD_STATUS.RELOAD_FEEDBACK_LIST,
  data: {
    reloadType,
  },
});

export const clearReloadFeedbackList = () => ({
  type: CONTINUOUS_FEEDBACK_RELOAD_STATUS.CLEAR_FEEDBACK_LIST,
});

export const reloadStatsState = () => ({
  type: CONTINUOUS_FEEDBACK_RELOAD_STATUS.RELOAD_FEEDBACK_STATS,
});

export const clearReloadStatsState = () => ({
  type: CONTINUOUS_FEEDBACK_RELOAD_STATUS.CLEAR_RELOAD_FEEDBACK_STATS_STATE,
});

export const onPrimaryAction = (primaryFunction) => ({
  type: CONTINUOUS_FEEDBACK_RELOAD_STATUS.ADD_PRIMARY_CALLBACK,
  payload: primaryFunction,
});
